var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user !== undefined)?_c('div',{attrs:{"id":"app"}},[(!_vm.user.uid || (_vm.user.uid && _vm.profile && _vm.profile.email))?_c('router-view',{attrs:{"id":"view","profile":_vm.profile,"user":_vm.user}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }